/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['*[_ngcontent-%COMP%]       .mce-tinymce{box-sizing:border-box!important}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9jb21wb25lbnRzL3NoYXJlZC9pbmxpbmUtZWRpdC9jb21wb25lbnRzL2N1c3RvbS1lZGl0b3IvY3VzdG9tLWVkaXRvci5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL25vZGUvYXBwL3NyYy9hcHAvY29tcG9uZW50cy9zaGFyZWQvaW5saW5lLWVkaXQvY29tcG9uZW50cy9jdXN0b20tZWRpdG9yL2N1c3RvbS1lZGl0b3IuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./compiled/src/app/components/shared/inline-edit/components/custom-editor/custom-editor.component.scss.shim.ngstyle.ts